precision highp float;

#pragma glslify: noise = require('glsl-noise/simplex/2d')
#pragma glslify: rotate2d = require('../lib.glsl')
#pragma glslify: ease = require(glsl-easings/quartic-in)
#pragma glslify: random = require(glsl-random) 

uniform float uProgress;
uniform sampler2D tDiffuse;
varying vec2 vUv;

float makePositive(float f) {
  return (f + 1.0) / 2.0;
}

float calcluateMagnitude(vec2 v) {
  float a = v.x * v.x;
  float b = v.y * v.y;

  return sqrt(a + b);
}

void main() {

  vec4 texelOriginal = texture2D(tDiffuse, vUv);
  float originalLightness = (texelOriginal.r + texelOriginal.g + texelOriginal.b) / 3.0;
  originalLightness = (originalLightness * 2.0) - 1.0;

  // convert to -1 > 1
  vec2 modUv = (vUv - 0.5) * 2.0;
  float magnitude = calcluateMagnitude(modUv);

  // stretch outwards
  modUv *= 1.0 - ((originalLightness + 0.25) * 1.0 * uProgress);

  // warp
  modUv = rotate2d(modUv, originalLightness * 0.5 * uProgress);

  // convert back to 0 > 1
  modUv = (modUv / 2.0) + 0.5;

  vec4 texel = texture2D(tDiffuse, modUv);
  float lightness = min((texel.r + texel.g + texel.b) / 3.0, 0.9);

  vec4 fragCol = mix(texel, vec4(0.0, 0.0, 0.0, 0.0), step(lightness, uProgress));
  gl_FragColor = fragCol;
}